<template>
  <div
    style="
      width: 100%;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-item: center;
    "
  >
    <div
      style="
        width: 400px;
        height: 250px;
        border: 1px solid #409eff;
        border-radius: 20px;
        padding: 20px;
      "
    >
      <h1>Accedi</h1>
      <el-form
        :model="loginData"
        label-width="100px"
      >
        <el-form-item label="Nome utente">
          <el-input v-model="loginData.username" />
        </el-form-item>
        <el-form-item label="Password">
          <el-input
            v-model="loginData.password"
            type="password"
            placeholder="Inserire password"
            show-password
          />
        </el-form-item>

        <el-form-item style="text-align: center; margin-left: 0px">
          <el-button
            type="primary"
            @click="onSubmit"
          >
            Accedi
          </el-button>
        </el-form-item>
      </el-form>
      
      <router-link
        :to="`/reset-password`"
        class="routerLink"
      >
        <el-link
          style="margin-top: 11px"
          :underline="false"
        >
          Hai dimenticato la password? clicca quì!
        </el-link>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { reactive, toRaw } from 'vue';
import { isLoggedStore } from '@/store/logged';
import authAPI from '../services/authAPI.js';
import { ElMessage } from 'element-plus';
import customerAPI from '@/services/customerAPI';

// Ruoli abilitati ad usare il gestionale amministrativo (backend F1: gli
// amministratori Simba hanno role "superadmin"; "admin" è ora l'amministratore
// di un partner e NON deve entrare qui).
const ALLOWED_ROLES = ['superadmin'];

export default {
  setup() {
    //Inizializzo variabili di utility e schema
    const router = useRouter();
    const store = isLoggedStore();
    const loginData = reactive({
      username: '',
      password: '',
    });

    const parseJwt = (token) => {
      if (!token) {
        return;
      }
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');

      return JSON.parse(window.atob(base64));
    };

    // Svuota completamente la sessione (token, scadenze, identità)
    const clearSession = () => {
      store.isLogged = false;
      store.viewMenu = false;
      store.accessToken = '';
      store.refreshToken = '';
      store.refreshExp = '';
      store.jwtExp = '';
      store.id = '';
      store.mail = '';
      store.role = '';
      store.employee = {};
    };

    //Inizializzo i pulsanti
    const onSubmit = async () => {
      let response;
      try {
        response = await authAPI.login(toRaw(loginData));
      } catch (error) {
        const status = error?.response?.status;
        ElMessage({
          message:
            status === 401 || status === 404
              ? 'Username o password errati'
              : 'Errore durante il login, riprova più tardi',
          type: 'error',
        });
        return;
      }

      try {
        const auth = parseJwt(response.data.access_token);
        const authRefresh = parseJwt(response.data.refreshtoken);

        if (!auth || !ALLOWED_ROLES.includes(auth.user?.role)) {
          // Utente valido ma non abilitato a questo gestionale: non
          // conserviamo alcun token.
          clearSession();
          ElMessage({ message: 'Non sei autorizzato', type: 'error' });
          return;
        }

        store.accessToken = response.data.access_token;
        store.refreshToken = response.data.refreshtoken;
        store.refreshExp = authRefresh.exp * 1000;
        store.jwtExp = auth.exp * 1000;

        store.id = auth.sub;
        store.mail = auth.user.mail;
        store.role = auth.user.role;

        // Identità dell'utente loggato: GET /customer/{id} con l'id del token.
        try {
          const me = await customerAPI.getCustomerById(auth.sub);
          store.employee = toRaw(me.data);
        } catch (error) {
          console.error('Impossibile caricare il profilo utente', error);
          store.employee = { mail: auth.user.mail };
        }

        store.isLogged = true;
        router.push('/booking');
      } catch (error) {
        console.error('errore inatteso', error);
        clearSession();
        ElMessage({ message: 'Errore inatteso durante il login', type: 'error' });
      }
    };

    return {
      loginData,
      onSubmit,
      store,
    };
  },
};
</script>